// extracted by mini-css-extract-plugin
var _1 = "home-module__home___b208o";
export { _1 as "home" }
